import { api } from './client';

export interface AirwallexSettings {
  configured: boolean;
  clientId?: string;
  /** 掩码后的尾号。后端**永远不会**回明文密钥。 */
  apiKeyHint?: string;
  /** 本组织的 API 根地址（沙箱 / 生产）。按组织存，不是全局环境变量。 */
  baseUrl: string;
  /** scoped key 的目标账户 ID。 */
  loginAs?: string | null;
  lastVerifiedAt?: string | null;
  updatedAt?: string;
}

export async function getAirwallexSettings() {
  const { data } = await api.post<AirwallexSettings>('/settings/airwallex/get', {});
  return data;
}

export async function saveAirwallexSettings(input: {
  clientId: string;
  apiKey: string;
  baseUrl: string;
  loginAs?: string;
}) {
  const { data } = await api.post<AirwallexSettings>('/settings/airwallex/save', input);
  return data;
}

export async function testAirwallexSettings() {
  const { data } = await api.post<{ ok: true; verifiedAt: string }>('/settings/airwallex/test', {});
  return data;
}

export async function deleteAirwallexSettings() {
  const { data } = await api.post<{ ok: true }>('/settings/airwallex/delete', {});
  return data;
}
